module.exports = __webpack_public_path__ + "img/centro3.4f8fea4d.jpg";